import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { usePublicList } from '../hooks/usePublicList';
import { buildImageUrl } from '../api/client';

export default function DoctorDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: doctors, loading } = usePublicList('doctors');
  const doc = doctors.find((d) => String(d.id) === String(id));

  if (loading) return <section className="section"><div className="container"><p style={{ textAlign: 'center', color: '#6b7280' }}>Yüklənir...</p></div></section>;
  if (!doc) return <section className="section"><div className="container"><p style={{ textAlign: 'center' }}>Həkim tapılmadı</p></div></section>;

  return (
    <section className="section">
      <div className="container">
        <button onClick={() => navigate('/hekimler')} style={{ background: 'transparent', border: 'none', color: '#17b4b4', fontWeight: 600, cursor: 'pointer', marginBottom: 20 }}>← Həkimlərə qayıt</button>
        <div className="doc-detail">
          <div className="col">
            <h4>Təhsili</h4>
            <p>{doc.education}</p>
          </div>
          <div className="col">
            <h4>Müalicə etdiyi xəstəliklər</h4>
            <p>{doc.diseases}</p>
          </div>
          <div className="doc-side">
            <h5>{doc.name}</h5>
            <p style={{ marginBottom: 12 }}>{doc.specialty}</p>
            <div className="thumb"><img src={buildImageUrl(doc.image)} alt={doc.name} /></div>
          </div>
        </div>
      </div>
    </section>
  );
}
